import React from 'react'
import { Button } from 'antd'
import { CloseOutlined, MenuOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { openMenu, closeMenu } from 'action/menu'
import classnames from 'classnames'
import styles from './index.scss'

const SidebarToggle = ({ open, menuOpen, close, mobile }) => (
  <Button
    className={classnames(styles.toggle_button, menuOpen ? styles.open_toggle_button : styles.close_toggle_button)}
    onClick={menuOpen ? close : open}
  >

    {menuOpen
    ? (<CloseOutlined />)
    : (<MenuOutlined />)
    }
  </Button>
)

SidebarToggle.propTypes = {
  close: PropTypes.func,
  menuOpen: PropTypes.bool,
  mobile: PropTypes.bool,
  open: PropTypes.func
}

const mapStateToProps = (state) => ({
  menuOpen: state.menu.open,
  mobile: state.menu.mobile
})

const mapDispatchToProps = (dispatch) => ({
  close: bindActionCreators(closeMenu, dispatch),
  open: bindActionCreators(openMenu, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SidebarToggle)
